import { Grid, Paper } from "@mui/material";

import useDashboard from "../../hooks/useDashboard";
import Loading from "../ui/Loading";

import DashboardFilters from "./DashboardFilters";
import OpsHealthCard from "./OpsHealthCard";
import AllIncompleteCallsCard from "./AllIncompleteCallsCard";
import CallsByStatusCard from "./CallsByStatusCard";
import CallsByProjectChart from "./CallsByProjectChart";

const Dashboard = () => {
  const {
    filters,
    updateFilters,
    opsHealth,
    callsByProject,
    callsByStatus,
    allIncompleteCount,
    allIncompleteCalls,
    getOpsHealth,
    callsDetail,
    getCalls,
    getAllIncompleteCallsCount,
    getAllIncompleteCalls,
    exportAllIncompleteCalls,
    isLoading,
  } = useDashboard();

  const handleFilterChange = (newFilters) => {
    updateFilters(newFilters);
  };

  if (isLoading && !opsHealth.data) {
    return <Loading />;
  }

  return (
    <>
      {/* Filters */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <DashboardFilters
          filters={filters}
          onChange={handleFilterChange}
        />
      </Paper>

      <Grid
        container
        spacing={3}
      >
        {/* Ops Health Row */}
        <Grid size={12}>
          <Paper sx={{ p: 2, mb: 3 }}>
            <OpsHealthCard
              data={opsHealth.data}
              isLoading={opsHealth.isLoading}
              error={opsHealth.error}
              filters={filters}
              onRefresh={getOpsHealth}
            />
            <AllIncompleteCallsCard
              filters={filters}
              allIncompleteCount={allIncompleteCount}
              getAllIncompleteCallsCount={getAllIncompleteCallsCount}
              allIncompleteCalls={allIncompleteCalls}
              getAllIncompleteCalls={getAllIncompleteCalls}
              exportAllIncompleteCalls={exportAllIncompleteCalls}
            />
          </Paper>
        </Grid>

        {/* Calls by Project Row */}
        <Grid size={6}>
          <CallsByProjectChart
            data={callsByProject.data}
            isLoading={callsByProject.isLoading}
            error={callsByProject.error}
            filters={filters}
            callsDetail={callsDetail}
            getCalls={getCalls}
          />
        </Grid>

        {/* Calls by Status Row */}
        <Grid size={6}>
          <CallsByStatusCard
            data={callsByStatus.data}
            isLoading={callsByStatus.isLoading}
            error={callsByStatus.error}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;
